import "./WorkAreas.module.css";
import KurumsalKimlikBasligi from "@/reusable_sections/Header";
import LitigationAndConsultancyServices from "./sections/LitigationAndConsultancyServices";
import LegalBranches from "./sections/LegalBranches";
import IndividualApplications from "./sections/IndividualApplications";
import KurumsalAltBilgi from "@/reusable_sections/Footer";
export default function WorkAreasPage() {
  return <div>
      <KurumsalKimlikBasligi />
      <LitigationAndConsultancyServices />
      <LegalBranches />
      <IndividualApplications />
      <KurumsalAltBilgi />
    </div>;
}